import React, {
  memo,
  useCallback,
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Col, Container, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import AgGridComponent from '../../../sharedcomponents/ag-grid/AgGrid';
import {
  ProductDeliveryPlatforms,
  ProductTypes,
  ReduxAction,
  UserId,
  Endpoints,
  GenericError,
  Active,
  PendingActive,
  PendingApproval,
  Cancelled,
  Rejected,
  Blocked,
  PendingInactive,
  Draft,
  AutoSelectPkgDist,
  Verbiage,
} from './../../../constants';
import { Notify } from './../../../sharedcomponents/Alert/Notify';
import smartHttp from '../../../helpers/smartHttp';
import DistributorsDropdown from './../../Entitlements/DistributorsDropdown';
import PackagesDropdown from './../../Entitlements/PackagesDropdown';
import InfoIcon from './../../../assets/icons/common/info.png';
import StickyTooltip from './../../../sharedcomponents/StickyTooltip/StickyTooltip';
import store from './../../../redux/store';
import StatusDefinitionHeader, {
  getStatusDefinition,
} from './../../Entitlements/StatusDefinitionHeader';
import UserSalesforceEntitlements from './user-salesforce-entitlements';
const UserEntitlements = memo(
  ({
    editMode,
    editData,
    distributorDataSet,
    entitlementMappingData,
    getEntitlementMappings,
    getUsers,
    onAddEditModalClose,
    formik,
    initialValue,
    userEntitlementsData,
    packageDataSet,
    getAllUserEntitlements,
    setLoading,
    setActiveTab,
    setIsUserIdEnabled,
    isViewerUser,
    userContractNumber,
    userContractInfo,
    updateEntitlementsChanged,
    isBPMReferral,
  }) => {
    //state variable declarations starts
    const gridApi = useRef(null);
    const gridContainerRef = useRef(null);
    const [rowData, setRowData] = useState();
    const [isRowDataLoaded, setIsRowDataLoaded] = useState(false);
    const [initialEntitlements, setInitialEntitlements] = useState([]);
    const [entitlementsChanged, setEntitlementsChanged] = useState(false);
    const [deselectRowsData, setDeselectRowsData] = useState([]);
    const [selectedPackages, setSelectedPackages] = useState([]);
    const [selectedDistributors, setSelectedDistributors] = useState([]);
    const [selectedDistributorsId, setSelectedDistributorsId] = useState([]);
    const [initialEntitlementIds, setInitialEntitlementIds] = useState([]);
    const [currentlySelectedEntitlements, setCurrentlySelectedEntitlements] =
      useState([]); // set value for default selection

    const [filteredPackages, setFilteredPackages] = useState();
    const [filteredDistributors, setFilteredDistributors] = useState();
    const [selectedParentCascade, setSelectedParentCascade] = useState();
    const [tooltip, setTooltip] = useState({});
    const [activeEntitlementSubTab, setActiveEntitlementSubTab] = useState(
      'subscription-manager',
    );
    const tooltipRef = useRef(null);
    const dispatch = useDispatch();
    //state variable declarations ends

    const defaultConfig = {
      rowModelType: 'clientSide',
      isExportCSV: false,
      isExportExcel: false,
      pivotPanelShow: '',
      suppressDragLeaveHidesColumns: true,
      pagination: false,
      isAutoSizeColumns: true,
      enableCharts: false,
      rowGroupPanelShow: false,
      sideBar: false,
      overlayNoRowsTemplate: 'This user has no entitlements',
      getRowId: (params) => String(params.data.productComponentId),
    };

    // const isFirstColumn = (params) => {
    //   let displayedColumns = params.api.getAllDisplayedColumns();
    //   let thisIsFirstColumn = displayedColumns[0] === params.column;
    //   if (thisIsFirstColumn) {
    //     return thisIsFirstColumn;
    //   }
    // };
    const defaultColdef = {
      sortable: true,
      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      menuTabs: ['generalMenuTab', 'filterMenuTab'],
    };
    const getColumnClass = (params) => {
      if (
        (params?.node?.data?.status === Cancelled ||
          params?.node?.data?.status === PendingInactive ||
          params?.node?.data?.status === Rejected) &&
        !isRowDataLoaded
      ) {
        return 'unselected-entitlement-row';
      }

      if (
        (!params?.node?.data?.status ||
          params?.node?.data?.status === Cancelled ||
          params?.node?.data?.status === PendingInactive ||
          params?.node?.data?.status === Rejected) &&
        params?.node?.isSelected() &&
        isRowDataLoaded
      ) {
        return 'new-selected-entitlement-row';
      }
      if (
        params?.node?.data?.status &&
        !params?.node?.isSelected() &&
        isRowDataLoaded
      ) {
        return 'unselected-entitlement-row';
      } else {
        return '';
      }
    };

    const distributorGetter = (params) => {
      if (params?.data)
        return (
          params?.data?.distributor +
          ' : ' +
          params?.data?.distributorPlatform +
          (params?.data?.deliveryType?.toLowerCase() !== 'web'
            ? ' (' + params?.data?.deliveryType + ')'
            : '')
        );

      return '';
    };
    // Custom Checkbox Cell Renderer
    const CheckboxCellRenderer = (props) => {
      const isBlocked = props.data?.status === Blocked;
      if (editData?.groupId || isViewerUser) {
        return <span>{props.data?.packageName}</span>;
      }
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input
            type="checkbox"
            checked={props.node.isSelected()}
            disabled={isBlocked}
            onChange={() => {
              if (!isBlocked) {
                props.node.setSelected(!props.node.isSelected());
              }
            }}
            style={{
              cursor: isBlocked ? 'not-allowed' : 'pointer',
              height: '17px',
              width: '17px',
              minWidth: '17px',
              minHeight: '17px',
              accentColor: 'var(--ag-alpine-active-color)',
            }}
            title={
              isBlocked
                ? 'Entitlement is currently blocked. There are no actions pending at your end. Hover over the "Blocked reason" for more details.'
                : ''
            }
          />
          <span>{props.data?.packageName}</span>
        </div>
      );
    };

    const entitlementsColumns = [
      {
        headerName: '',
        field: 'id',
        resizable: true,
        filter: 'agTextColumnFilter',
        suppressHeaderMenuButton: true,
        sortable: false,
        hide: true,
      },
      {
        headerName: 'Package',
        headerTooltip: 'Package',
        field: 'packageName',
        tooltipField: 'packageName',
        initialFlex: 3,
        cellClass: getColumnClass,
        headerCheckboxSelection:
          editData?.groupId || isViewerUser ? false : true,
        cellRenderer: CheckboxCellRenderer,
      },
      {
        headerName: 'Delivery Platform (Type)',
        headerTooltip: 'Delivery Platform (Type)',
        field: 'deliveryPlatform',
        initialFlex: 3,
        valueGetter: distributorGetter,
        tooltipValueGetter: distributorGetter,
        cellClass: getColumnClass,
      },
      {
        headerName: 'Contract ID',
        headerTooltip: 'Contract ID',
        field: 'contractNumber',
        tooltipField: 'contractNumber',
        initialFlex: 2,
        cellClass: getColumnClass,
      },
      {
        headerName: 'Status',
        headerTooltip: 'Status',
        field: 'status',
        tooltipValueGetter: (params) => getStatusDefinition(params.value),
        headerComponent: StatusDefinitionHeader,
        initialFlex: 3,
        cellClass: getColumnClass,
        cellRenderer: (params) => {
          const isTooltipVisible =
            tooltip.showTooltip && tooltip.rowId === params.data.id;

          return (
            <div style={{ position: 'relative' }} data-row-id={params.data.id}>
              <span>
                {params.value}
                {params.value === 'Blocked' && (
                  <img
                    src={InfoIcon}
                    className="info-icon"
                    style={{
                      cursor: 'pointer',
                      marginLeft: '5px',
                      width: '20px',
                    }}
                    title={params.data.blockedReason}
                    onClick={(event) => {
                      handleTooltipClick(
                        event,
                        params.data.id,
                        params.data.blockedReason,
                      );
                    }}
                  />
                )}
                {isTooltipVisible && (
                  <StickyTooltip
                    ref={tooltipRef}
                    text={tooltip.text}
                    onClose={() => setTooltip({})}
                  />
                )}
              </span>
            </div>
          );
        },
      },
    ];

    const handleTooltipClick = (event, rowId, blockedReason) => {
      event.stopPropagation();

      if (tooltip.rowId === rowId) {
        setTooltip({});
      } else {
        setTooltip({
          showTooltip: true,
          rowId,
          text: blockedReason,
        });
      }
    };

    const getPostEntitlementChanges = () => {
      let contactId =
        initialValue.contactId !== '' ? initialValue.contactId : -1;
      let entitlementChanges = [];

      gridApi.current.api.forEachNode((node) => {
        // remove entitlements that have a status and aren't selected
        if (
          node.data?.status &&
          [Active, PendingActive, PendingApproval, Blocked, Draft].some(
            (status) => node.data?.status === status,
          ) &&
          !node.isSelected()
        ) {
          entitlementChanges.push({
            contactid: contactId,
            productcomponentid: node.data.productComponentId,
            status: PendingInactive,
            contractNumber: node.data.contractNumber,
            distributor: node.data.distributor,
            distributorDisplayName: node.data.distributorDisplayName,
            distributorPlatform: node.data.distributorPlatform,
            distributorPlatformDisplayName:
              node.data.distributorPlatformDisplayName,
            distributorId: node.data.distributorId,
          });
        }
        // add entitlements that don't have a status and are selected
        if (
          (!node.data?.status ||
            [Cancelled, PendingInactive, Rejected].some(
              (status) => node.data?.status === status,
            )) &&
          node.isSelected()
        ) {
          entitlementChanges.push({
            contactid: contactId,
            productcomponentid: node.data.productComponentId,
            // FEATURE DISABLED (Release july-2026) - status: isBPMReferral ? Draft : PendingActive,
            status: PendingActive,
            contractNumber: node.data.contractNumber,
            distributor: node.data.distributor,
            distributorDisplayName: node.data.distributorDisplayName,
            distributorPlatform: node.data.distributorPlatform,
            distributorPlatformDisplayName:
              node.data.distributorPlatformDisplayName,
            distributorId: node.data.distributorId,
          });
        }
      });
      return entitlementChanges;
    };

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          tooltipRef.current &&
          !tooltipRef.current.contains(event.target) &&
          !event.target.classList.contains('info-icon')
        ) {
          setTooltip({});
        }
      };

      if (tooltip.showTooltip) {
        document.addEventListener('click', handleClickOutside);
      } else {
        document.removeEventListener('click', handleClickOutside);
      }

      return () => {
        document.removeEventListener('click', handleClickOutside);
      };
    }, [tooltip.showTooltip]);

    useEffect(() => {
      const reduceCallback = setTimeout(() => {
        if (rowData?.length > 0) {
          setSelectionsInGrid();
        } else {
          if (rowData?.length === 0 && initialEntitlements?.length === 0) {
            setEntitlementsChanged(false);
          }
        }
      }, 100);
      return () => clearTimeout(reduceCallback);
    }, [rowData]);

    useEffect(() => {
      // clear tooltip if grid data changes
      setTooltip({});
      // Cartesian Start
      if (
        selectedPackages?.length > 0 ||
        selectedDistributors?.length > 0 ||
        (selectedPackages?.length === 0 && selectedDistributors?.length === 0)
      ) {
        if (
          selectedPackages.length === 0 &&
          selectedDistributors.length === 0
        ) {
          // Reset grid back to initial entitlements when all selections cleared
          if (initialEntitlements?.length > 0) {
            setDeselectRowsData([]);
            setRowData([...initialEntitlements]);
          }
          return;
        }
        let newSelectedDistributors = [...selectedDistributors];
        let newSelectedDistributorsId = [...selectedDistributorsId];
        let autoSelectDist;
        if (selectedPackages.length > 0 && isAnyAutoSelectPkg()) {
          autoSelectDist = filteredDistributors?.results?.find(
            (obj) =>
              String(obj.distributorId) ===
              AutoSelectPkgDist.Market_Basics.distId,
          );
          if (autoSelectDist) {
            newSelectedDistributors = [
              ...selectedDistributors,
              autoSelectDist.distributor +
                ':' +
                autoSelectDist.distributorPlatform +
                ':' +
                autoSelectDist.deliveryType,
            ];
            newSelectedDistributorsId = [
              ...selectedDistributorsId,
              autoSelectDist.distributorId,
            ];
          }
        }

        // Wait until both sides of the cartesian selection are available.
        // Recomputing on a package-only selection produces an empty result and
        // can incorrectly mark existing entitlements as deselected.
        if (
          selectedPackages.length === 0 ||
          newSelectedDistributors.length === 0
        ) {
          // Reset grid back to initial entitlements when one side is empty
          if (initialEntitlements?.length > 0) {
            setDeselectRowsData([]);
            setRowData([...initialEntitlements]);
          }
          return;
        }
        const cartesian = (...selectedPackages) =>
          selectedPackages.reduce((selectedPackages, newSelectedDistributors) =>
            selectedPackages.flatMap((d) =>
              newSelectedDistributors.map((e) => [d, e].flat()),
            ),
          );
        const result = cartesian(selectedPackages, newSelectedDistributors);
        const newRows = [];

        result.forEach((product) => {
          const splitDist = product[1].split(':');
          const matchingEntitlement = userEntitlementsData.find(
            (entitlement) => {
              const baseMatch =
                entitlement.packageName === product[0] &&
                entitlement.distributor === splitDist[0] &&
                entitlement.distributorPlatform === splitDist[1] &&
                entitlement.deliveryType === splitDist[2] &&
                !ProductTypes.includes(entitlement.productType) &&
                (entitlement.packageName.includes(
                  AutoSelectPkgDist.Market_Basics.pkgName,
                ) ||
                  newSelectedDistributorsId.some(
                    (id) => id == entitlement.distributorId,
                  ));

              return (
                baseMatch &&
                userContractNumber?.includes(entitlement.contractNumber)
              );
            },
          );
          if (matchingEntitlement) {
            newRows.push(matchingEntitlement);
          }
        });

        let filteredRows = newRows.filter(
          (row) => !initialEntitlementIds.includes(row.productComponentId),
        );
        filteredRows.push(
          ...initialEntitlements.filter((row) =>
            newRows.some(
              (ie) =>
                ie.productComponentId === row.productComponentId &&
                (row.status === Cancelled ||
                  row.status === PendingInactive ||
                  row.status === Rejected),
            ),
          ),
        );

        // Use React state as source of truth when grid selection is empty
        // (grid selection can be stale after setRowData replaced rows)
        const gridSelectedRows = gridApi?.current?.api?.getSelectedRows() || [];
        const effectiveSelected =
          gridSelectedRows.length > 0
            ? gridSelectedRows
            : currentlySelectedEntitlements?.length > 0
              ? currentlySelectedEntitlements
              : initialEntitlements.filter(
                  (x) =>
                    x.status !== Cancelled &&
                    x.status !== PendingInactive &&
                    x.status !== Rejected,
                );

        const selectedRows = effectiveSelected.filter(
          (se) =>
            !(
              [Cancelled, PendingInactive, Rejected].includes(se.status) &&
              (filteredRows?.length == 0 ||
                filteredRows?.some(
                  (fr) => fr.productComponentId !== se.productComponentId,
                ))
            ),
        );
        const deselectedRows = rowData?.filter(
          (row) =>
            row.status &&
            !selectedRows?.some(
              (selectedRow) =>
                selectedRow.productComponentId === row.productComponentId,
            ) &&
            !filteredRows?.some(
              (fr) => fr.productComponentId === row.productComponentId,
            ),
        );
        setDeselectRowsData(deselectedRows);
        //add unique rows because cancelled and pending inactive already added filtered rows variable
        setRowData([
          ...filteredRows,
          ...initialEntitlements?.filter(
            (x) =>
              !filteredRows.some(
                (y) => x.productComponentId === y.productComponentId,
              ),
          ),
        ]);
        gridApi.current.api.setGridOption('loading', false);

        setTimeout(() => {
          const postData = {
            userEntitlements: getPostEntitlementChanges(),
            userId: UserId,
          };
          dispatch({
            type: ReduxAction.updateEntitlement,
            payload: {
              updatedEntitlements: postData,
              initialEntitlements: initialEntitlements,
            },
          });
        }, 300);
      }
    }, [selectedPackages, selectedDistributors]);
    // filter and display user's initial entitlements
    useEffect(() => {
      // Disable loading once api is completed
      if (
        entitlementMappingData?.length === 0 &&
        userEntitlementsData?.length === 0 &&
        gridApi?.current
      ) {
        gridApi.current?.api?.showNoRowsOverlay();
        gridApi.current.api.setGridOption('loading', false);
      }

      if (entitlementMappingData && userEntitlementsData.length > 0) {
        let filtered = entitlementMappingData.filter(function (el) {
          return (
            el.contactId === formik.getFieldProps('contactId').value &&
            (!userContractNumber?.length ||
              userContractNumber.includes(el.contractNumber)) &&
            !ProductDeliveryPlatforms.includes(el.distributor) &&
            !ProductTypes.includes(el.productType)
          );
        });

        if (filtered?.length === 0) {
          setIsRowDataLoaded(true);
          gridApi.current.api.showNoRowsOverlay();
        } else {
          gridApi.current.api.hideOverlay();
        }

        let ids = [];
        filtered.forEach((initialEntitlement) => {
          ids.push(initialEntitlement.productComponentId);
        });

        setInitialEntitlements(filtered);
        setInitialEntitlementIds(ids);
        setRowData(filtered);
        gridApi.current.api.setGridOption('loading', false);

        let selectedEntitlements = [];
        selectedEntitlements = filtered.filter(
          (x) =>
            x.status != Cancelled &&
            x.status != PendingInactive &&
            x.status != Rejected,
        );

        dispatch({
          type: ReduxAction.updateEntitlement,
          payload: {
            initialEntitlements: filtered,
            selectedEntitlements: selectedEntitlements,
          },
        });
      }
    }, [userEntitlementsData, entitlementMappingData, userContractNumber]);

    useEffect(() => {
      let initialEntitlementsToValidateChanges = initialEntitlements.filter(
        (x) =>
          x.status != Cancelled &&
          x.status != PendingInactive &&
          x.status != Rejected,
      );

      // Compare based on productComponentId instead of full object equality
      const getIds = (arr) =>
        (arr || []).map((x) => x.productComponentId).sort();
      const selectedIds = getIds(currentlySelectedEntitlements);
      const initialIds = getIds(initialEntitlementsToValidateChanges);

      const arraysEqual = (a, b) =>
        a.length === b.length && a.every((v, i) => v === b[i]);

      if (arraysEqual(selectedIds, initialIds)) {
        setEntitlementsChanged(false);
        updateEntitlementsChanged(false);

        dispatch({
          type: ReduxAction.updateEntitlement,
          payload: {
            selectedEntitlements: currentlySelectedEntitlements,
          },
        });
      } else {
        setEntitlementsChanged(true);
        updateEntitlementsChanged(true);
      }
    }, [currentlySelectedEntitlements]);

    useEffect(() => {
      // Set initial state
      if (packageDataSet) setFilteredPackages(packageDataSet);
      if (distributorDataSet) setFilteredDistributors(distributorDataSet);
    }, [packageDataSet, distributorDataSet]);

    useEffect(() => {
      if (selectedParentCascade === 'PackageDropdown' && userEntitlementsData) {
        // Filter distributor based on package selection
        let filterData = userEntitlementsData.filter(
          (el) =>
            selectedPackages.includes(el.packageName) &&
            !ProductTypes.includes(el.productType),
        );
        setFilteredDistributors({ results: filterData });
      }
    }, [selectedPackages]);

    useEffect(() => {
      if (
        selectedParentCascade === 'DistributorDropdown' &&
        userEntitlementsData
      ) {
        // Filter packages based on distributor selection and contract number
        let filterData = userEntitlementsData.filter((el) => {
          return (
            selectedDistributorsId.includes(el.distributorId) &&
            userContractNumber?.includes(el.contractNumber) &&
            !ProductTypes.includes(el.productType)
          );
        });
        setFilteredPackages({ results: filterData });
      }
    }, [selectedDistributorsId]);
    //useeffect ends

    useEffect(() => {
      if (tooltip.showTooltip && gridContainerRef.current) {
        const scrollContainer =
          gridContainerRef.current.querySelector('.ag-body-viewport');
        const handleScroll = () => {
          const rowElement = document.querySelector(
            `[data-row-id="${tooltip.rowId}"]`,
          );
          if (rowElement) {
            const gridRect = scrollContainer.getBoundingClientRect();
            const rowRect = rowElement.getBoundingClientRect();

            // hide tooltip when the row is fully outside the viewport
            if (
              rowRect.bottom <= gridRect.top ||
              rowRect.top >= gridRect.bottom
            ) {
              setTooltip({});
            }
          } else {
            setTooltip({});
          }
        };

        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', handleScroll);
        }

        return () => {
          if (scrollContainer) {
            scrollContainer.removeEventListener('scroll', handleScroll);
          }
        };
      }
    }, [tooltip.showTooltip, tooltip.rowId]);

    //functions
    const cascadingPackageDistributor = () => {
      // On empty selection, set to default data
      if (
        selectedPackages.length === 0 &&
        selectedParentCascade === 'PackageDropdown'
      ) {
        setFilteredDistributors(distributorDataSet);
      } else if (
        selectedDistributorsId.length === 0 &&
        selectedParentCascade === 'DistributorDropdown'
      ) {
        setFilteredPackages(packageDataSet);
      }

      // Cascading functionality to set which dropdown is parent
      if (selectedPackages.length === 0 && selectedDistributors.length === 0) {
        setSelectedParentCascade();
      } else if (!selectedParentCascade) {
        if (selectedPackages.length > 0) {
          setSelectedParentCascade('PackageDropdown');
        }
        if (selectedDistributors.length > 0) {
          setSelectedParentCascade('DistributorDropdown');
        }
      }
    };

    // Memoized selection to stop loop from dropdown callback
    const cascadingPackageDistributorMemo = useMemo(
      cascadingPackageDistributor,
      [selectedPackages, selectedDistributors],
    );

    const onSelectionChanged = () => {
      gridApi.current.api.refreshCells();
      gridApi.current.api.forEachNode((node) => {
        if (node.data?.status === 'Blocked') {
          node.setSelected(true);
        }
      });
      let currentlySelected = [];
      gridApi.current.api.getSelectedNodes().forEach((node) => {
        currentlySelected.push(node.data);
      });
      setCurrentlySelectedEntitlements(currentlySelected);
    };

    let isFirstDataSelection = true;
    const setSelectionsInGrid = () => {
      gridApi.current.api.selectAll();
      const nodesToDeselect = [];
      if (isFirstDataSelection) {
        isFirstDataSelection = false;
        gridApi.current.api.forEachNode((node) => {
          // Deselect Cancelled and Pending Inactive entitlements
          if (
            [Cancelled, PendingInactive, Rejected].includes(node?.data?.status)
          )
            nodesToDeselect.push(node);
        });
      }

      if (isRowDataLoaded && deselectRowsData?.length > 0) {
        gridApi.current.api.forEachNode((node) => {
          if (
            deselectRowsData.some(
              (nd) => nd.productComponentId === node?.data?.productComponentId,
            )
          ) {
            nodesToDeselect.push(node);
          }
        });
      }
      gridApi.current.api.setNodesSelected({
        nodes: nodesToDeselect,
        newValue: false,
      });
      setIsRowDataLoaded(true);
      setDeselectRowsData([]);
    };
    const onEntitlementGridReadyHandler = (params) => {
      gridApi.current = params;
      params.api.setGridOption('loading', true);
    };

    useEffect(() => {
      if (!packageDataSet?.results?.length > 0) {
        if (userContractNumber?.length > 0) {
          getAllUserEntitlements(userContractNumber);
        }
        getEntitlementMappings();
      }
    }, [userContractNumber]);

    // update entitlements in DB
    const AddEntitlements = () => {
      try {
        let entitlementChanges = getPostEntitlementChanges();
        let postData = {
          userEntitlements: entitlementChanges,
          userId: UserId,
        };
        dispatch({
          type: ReduxAction.updateEntitlement,
          payload: {
            updatedEntitlements: postData,
            initialEntitlements: initialEntitlements,
            selectedEntitlements: currentlySelectedEntitlements,
          },
        });

        // check for channel partner match in changed entitlements
        let partnerMatch = false;

        let ManageUserIdDistributors =
          store.getState()?.dbConfig.ManageUserIdDistributors;

        for (const newEntitlement of entitlementChanges) {
          let match = distributorDataSet.results.find(
            (matchingEntitlement) =>
              matchingEntitlement.platformCategories == 'Channel Partners' &&
              matchingEntitlement.distributorId ==
                newEntitlement.distributorId &&
              ManageUserIdDistributors.some(
                (item) =>
                  item.distributorId === matchingEntitlement.distributorId,
              ),
          );

          if (
            match &&
            [PendingActive, Active, Draft].some(
              (status) => newEntitlement?.status === status,
            )
          ) {
            partnerMatch = true;
            break;
          }
        }

        if (partnerMatch) {
          setIsUserIdEnabled(true);
          setActiveTab('manage-user-ids-tab');
        } else {
          // save CI entitlements
          saveEntitlements(postData);
        }
      } catch (err) {}
    };

    const saveEntitlements = (postData, showAlert = true) => {
      setLoading(true);
      smartHttp
        .post(Endpoints.userentitlementsApi, postData)
        .then((res) => {
          if (res.data === 0) {
            smartHttp.clearCache(Endpoints.userentitlementsApi);
            afterUpdateAction('User Entitlements have been updated');
          }
        })
        .catch((err) => {
          // FEATURE DISABLED (Release july-2026) - LME Governance Check (Story 9836589)
          // let errorMsg =
          //   err?.response?.data === -3
          //     ? Verbiage.lmeEntitlementsGovernanceFailed
          //     : GenericError.somethingWentWrong;
          let errorMsg = GenericError.somethingWentWrong;
          Notify({
            alert: true,
            type: 'error',
            title: errorMsg,
          });
        })
        .finally(() => setLoading(false));
    };

    const afterUpdateAction = (displayMessage) => {
      getUsers();
      onAddEditModalClose();
      Notify({
        alert: true,
        type: 'success',
        title: displayMessage,
      });
    };

    const isAnyAutoSelectPkg = () => {
      try {
        let isAutoSelect = false;
        const marketBasicsSelected = selectedPackages.some((pkg) =>
          pkg.includes(AutoSelectPkgDist.Market_Basics.pkgName),
        );

        // Check if Market Basics is selected
        if (marketBasicsSelected) {
          const plattsConnectSelected = selectedDistributorsId.find(
            (dstId) => dstId == AutoSelectPkgDist.Market_Basics.distId,
          );
          // Platts Connect is not selected
          if (!plattsConnectSelected) {
            isAutoSelect = true;
          }
        }
        return isAutoSelect;
      } catch (error) {}
    };

    const callBackPackages = (params) => {
      let pkgs = [];
      params.forEach((pkg) => {
        pkgs.push(pkg.packageName);
      });
      setSelectedPackages(pkgs);
    };
    const callBackDistributors = (params) => {
      let dsts = [];
      let dstsId = [];
      params.forEach((dst) => {
        dsts.push(dst.distributor);
        dstsId.push(dst.distributorId);
      });
      setSelectedDistributors(dsts);
      setSelectedDistributorsId(dstsId);
    };

    return (
      <>
        <Container className={editData?.groupId ? 'pt-3' : 'pt-2-5'}>
          <div className="tabs-main entitlements-tabs-main entitlements-subtab">
            <Tabs
              fill
              justify
              defaultActiveKey="subscription-manager"
              activeKey={activeEntitlementSubTab}
              onSelect={(key) => setActiveEntitlementSubTab(key)}
            >
              <Tab
                eventKey="subscription-manager"
                title="Subscription Manager"
                className="subscription-manager-pane"
              >
                {!editData?.groupId && (
                  <Row>
                    <Col>
                      <div>
                        <PackagesDropdown
                          DataSet={filteredPackages}
                          callBackPackages={callBackPackages}
                          disabled={editData?.groupId}
                        />
                      </div>
                    </Col>
                    <Col>
                      <div>
                        <DistributorsDropdown
                          DataSet={filteredDistributors}
                          callBackDistributors={callBackDistributors}
                          disabled={editData?.groupId}
                        />
                      </div>
                    </Col>
                  </Row>
                )}
                {editData?.groupId && (
                  <Row>
                    <Col className="mb-2">
                      <span className="email-preference-note-label">
                        This user belongs to a group and cannot be edited
                      </span>
                    </Col>
                  </Row>
                )}
                <Row className="grid-tab-row">
                  <div className="ag-grid-modal-content" ref={gridContainerRef}>
                    <AgGridComponent
                      config={defaultConfig}
                      defaultColumnDef={defaultColdef}
                      data={rowData}
                      columns={entitlementsColumns}
                      onSelectionChanged={onSelectionChanged}
                      onGridReady={onEntitlementGridReadyHandler}
                    />
                  </div>
                </Row>
                <Row
                  className={
                    editData?.groupId
                      ? 'modal-row'
                      : 'modal-row entitlement-fix'
                  }
                >
                  <div className="col-6">
                    {!editData?.groupId && (
                      <span
                        title="Currently subscribed by other users"
                        className="currently-sub"
                      >
                        🟢 Currently subscribed by other users
                      </span>
                    )}
                  </div>
                  <Form className="col-6">
                    <Form.Group className="user-save-btn-body">
                      <button
                        type="button"
                        disabled={
                          !entitlementsChanged ||
                          editData?.groupId ||
                          isViewerUser
                        }
                        onClick={AddEntitlements}
                        className="user-save-btn btn btn-dark float-end btn-opacity"
                      >
                        {editMode ? 'Update' : 'Save'}
                      </button>
                    </Form.Group>
                  </Form>
                </Row>
              </Tab>
              <Tab eventKey="salesforce" title="Salesforce">
                <UserSalesforceEntitlements
                  userContractNumber={userContractNumber}
                  emailId={formik.values?.email || editData?.email}
                />
              </Tab>
            </Tabs>
          </div>
        </Container>
      </>
    );
  },
  (op, np) =>
    op?.editData === np?.editData &&
    op?.entitlementMappingData === np?.entitlementMappingData &&
    op?.initialValue === np?.initialValue &&
    op?.packageDataSet === np?.packageDataSet &&
    op?.userEntitlementsData === np?.userEntitlementsData &&
    op?.distributorDataSet === np?.distributorDataSet &&
    op?.userContractInfo === np?.userContractInfo &&
    op?.userContractNumber === np?.userContractNumber,
);

export default UserEntitlements;
